import { createContext, useEffect, useMemo, useState } from 'react';
import { useFlag } from '@openfeature/react-sdk';
import { FEATURE_FLAGS } from '../../../constants/constants';
import useNRQuery from '../../../graphql/useNRQuery';
import { buildGetOrgLevelSettings } from '../../../graphql/queries/orgs';

export const OrgLevelSettingsContext = createContext({
  orgLevelSettings: null,
  isLoadingSettings: false
});

function NROrgLevelSettingsContextWrapper({ children }) {
  const { value: isRiseAiConversationalGptEnabled } = useFlag(FEATURE_FLAGS.RISE_AI_CONVERSATIONAL_GPT_SETTINGS, false);
  const { value: isRiseAIInsightsReportEnabled } = useFlag(FEATURE_FLAGS.RISE_AI_INSIGHTS_REPORT_SETTINGS, false);
  const { value: isAutoRemediationsSettingsEnabled } = useFlag(FEATURE_FLAGS.AUTO_REMEDIATIONS_SETTINGS, false);
  const { value: isSecretScanningSettingsEnabled } = useFlag(FEATURE_FLAGS.SECRET_SCANNING_SETTINGS, false);
  const { value: isAdvancedSettingsEnabled } = useFlag(FEATURE_FLAGS.ADVANCED_SETTINGS, false);

  // Build dynamic query based on feature flags
  const GET_ORG_LEVEL_SETTINGS = useMemo(
    () =>
      buildGetOrgLevelSettings({
        isRiseAiConversationalGptEnabled,
        isRiseAIInsightsReportEnabled,
        isAutoRemediationsSettingsEnabled,
        isSecretScanningSettingsEnabled,
        isAdvancedSettingsEnabled
      }),
    [isRiseAiConversationalGptEnabled, isRiseAIInsightsReportEnabled, isAutoRemediationsSettingsEnabled, isSecretScanningSettingsEnabled, isAdvancedSettingsEnabled]
  );

  const [orgLevelSettings, isLoadingSettings] = useNRQuery({
    query: GET_ORG_LEVEL_SETTINGS,
    qlObjKey: 'orgLevelSettings',
    defaultValue: null,
    options: {
      fetchPolicy: 'network-only'
    }
  });

  const defaultValues = {
    orgLevelSettings,
    isLoadingSettings
  };

  return <OrgLevelSettingsContext.Provider value={defaultValues}>{children}</OrgLevelSettingsContext.Provider>;
}

export default NROrgLevelSettingsContextWrapper;
